import { AlertWindow } from '@sunwebgroup/uds-ui/alert-window'
import { Button } from '@sunwebgroup/uds-ui/button'
import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'

export function BookingDeletionErrorAlertContent() {
  const { formatMessage } = useIntl()
  const { bookingDeletionErrorDismissed } = useBookingDetailsActions()

  return (
    <AlertWindow.Content
      text={formatMessage({ id: 'booking_details_manage_booking_delete_window_error_title' })}
      supportingText={formatMessage({ id: 'booking_details_manage_booking_delete_window_error_text' })}
      renderPrimaryActionSlot={() => (
        <Button
          onClick={bookingDeletionErrorDismissed}
          ariaLabel={formatMessage({ id: 'booking_details_manage_booking_delete_window_error_button_label' })}
        >
          {formatMessage({ id: 'booking_details_manage_booking_delete_window_error_button_label' })}
        </Button>
      )}
    />
  )
}
